import { apiClient } from "./client";

function extractData(response) {
  return response.data?.data ?? response.data;
}

export async function fetchNotifications({ limit = 30, unread = false } = {}) {
  const response = await apiClient.get("/notifications", {
    params: { limit, unread: unread ? "true" : undefined },
  });
  return extractData(response);
}

export async function fetchWorkforceAlerts() {
  const response = await apiClient.get("/notifications/workforce-alerts");
  return extractData(response);
}

export async function fetchUnreadCount() {
  const response = await apiClient.get("/notifications/unread-count");
  const data = extractData(response);
  return typeof data === "object" && data !== null ? data.count : 0;
}

export async function markNotificationRead(id) {
  const response = await apiClient.patch(`/notifications/${id}/read`);
  return extractData(response);
}

export async function markAllNotificationsRead() {
  const response = await apiClient.patch("/notifications/read-all");
  return extractData(response);
}

export async function deleteNotification(id) {
  const response = await apiClient.delete(`/notifications/${id}`);
  return extractData(response);
}
